import React  from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function UsersHasPermissionsTable({ style = {}, isEditable = false, onRemove = false, ...rest }) {
    const { umeFolderPermissions } = rest;
    const columns = [{
        Header: "Supplier",
        headerClassName: "text-left",
        accessor: "supplier",
        style: {
            whiteSpace: "unset"
        }
    }, {
        Header: "User",
        headerClassName: "text-left",
        accessor: "userName",
        style: {
            whiteSpace: "unset"
        }
    }];

    if (isEditable) {
        columns.push({
            id: "actions",
            Header: "Actions",
            className: "text-center",
            Cell: ({ original }) => (
                <button
                    className="btn btn-danger"
                    onClick={() => onRemove(original.id)}
                >
                    <FontAwesomeIcon icon="times" />
                </button>
            ),
            filterable: false,
        });
    }

    return (
        <ReactTable
            data={umeFolderPermissions}
            columns={columns}
            pageSize={Math.max(6, umeFolderPermissions.length)}
            showPagination={false}
            loading={false}
            filterable={false}
            style={style}
            headerClassName="table-header"
            className="-striped -highlight"
        />
    );
}

const mapStateToProps = state => ({
    umeFolderPermissions: state.fileManager.umeFolderPermissions,
});

export default connect(
    mapStateToProps,
)(UsersHasPermissionsTable);
